<template>
  <el-dialog title="是否确认同意申请" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">

      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="上传图片" prop="url">
        <moreImageUpload v-model="form.url" :limit="9" hintText="限制9张" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custApi from '@/api/cust'
import userApi from '@/api/sys/user'
import MoreImageUpload from "@/components/MoreImageUpload";
function initFormBean() {
  const formBean = {
    remark: null,
    url: [],
  }
  return formBean
}

export default {
  components: { MoreImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        // url: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
      isRepSub: false,
      currentRow: null
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    handleUpdate(row) {
      this.resetForm()
      this.form.idStr = row.id
      this.currentRow = row
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.url = params.url.length ? params.url.map(banner => banner.url).toString() : ''
          if (this.isRepSub) return
          this.isRepSub = true
          custApi.agreeApply(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      // 如果 companyName 字段没有值，则清除缓存
      if (this.currentRow) {
        const companyName = this.currentRow.companyName
        if ((!companyName || companyName === null || companyName === '') && this.currentRow.customerUserId) {
          userApi.delCache({ userId: this.currentRow.customerUserId }).then(() => {
           
          }).catch(err => {
           
          })
        }
      } 
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
